
import { useEffect, useState } from "react";
import { Edit, Trash } from "lucide-react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from '../../../Axios'


export default function ManageTenders() {
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [updatedTender, setUpdatedTender] = useState({
    description: "",
    publicationDate: "",
    lastSubmissionDate: "",
    openingDate: "",
    pdfUrl: "",
  });
  const [currentTenderId, setCurrentTenderId] = useState(null);

  useEffect(() => {
    const fetchTenders = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_BASE_URL}/api/v1/tenders`);
        setTenders(response.data);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch tenders.");
      } finally {
        setLoading(false);
      }
    };

    fetchTenders();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedTender((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    try {
      const response = await api.put(
        `/api/v1/tenders/${currentTenderId}`,
        updatedTender
      );

      setTenders((prevTenders) =>
        prevTenders.map((tender) =>
          tender._id === currentTenderId ? { ...tender, ...response.data } : tender
        )
      );
      toast.success("Tender updated successfully!");
      setShowUpdateForm(false);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to update tender.");
      toast.error("Failed to update tender.");
    }
  };


  const handleDelete = async (id) => {
    try {
      await api.delete(`/api/v1/tenders/${id}`);
      setTenders((prevTenders) => prevTenders.filter((tender) => tender._id !== id));
      toast.success("Tender deleted successfully!");
    } catch (err) {
      setError(err.response?.data?.message || "Failed to delete tender.");
      toast.error("Failed to delete tender.");
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <span className="text-xl text-gray-700">Loading...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <span className="text-xl text-red-600">{error}</span>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-gradient-to-r py-6 sm:py-8 shadow-lg">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-black">Tenders</h1>
          <nav className="text-xs sm:text-sm text-gray-600 mt-2">
            <a href="/" className="hover:underline">Home</a>
            <span className="mx-2">/</span>
            <span className="font-light">Tenders</span>
          </nav>
        </div>
      </header>

      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
        {/* Action Button */}
        <a
          href="https://mptenders.gov.in/nicgep/app"
          target="_blank"
          rel="noopener noreferrer"
          className="block bg-gradient-to-r from-teal-600 to-cyan-600 text-white font-semibold text-sm sm:text-lg py-3 sm:py-4 rounded-md text-center shadow-md hover:shadow-lg transition-transform transform hover:scale-105 mb-6 sm:mb-8"
        >
          Click Here To View All TENDERS MADHYA PRADESH &gt;
        </a>

        {/* Update Tender Form */}
        {showUpdateForm && (
          <div className="bg-white p-4 sm:p-6 shadow-md rounded-md mb-6 sm:mb-8">
            <h2 className="text-xl sm:text-2xl font-bold mb-4">Update Tender</h2>
            <form className="space-y-4">
              <div>
                <label htmlFor="description" className="block text-sm font-medium text-gray-700">Description</label>
                <input
                  type="text"
                  id="description"
                  name="description"
                  value={updatedTender.description}
                  onChange={handleInputChange}
                  className="w-full p-2 text-sm border border-gray-300 rounded-md"
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="publicationDate" className="block text-sm font-medium text-gray-700">Publication Date</label>
                  <input
                    type="date"
                    id="publicationDate"
                    name="publicationDate"
                    value={updatedTender.publicationDate}
                    onChange={handleInputChange}
                    className="w-full p-2 text-sm border border-gray-300 rounded-md"
                  />
                </div>
                <div>
                  <label htmlFor="lastSubmissionDate" className="block text-sm font-medium text-gray-700">Last Submission Date</label>
                  <input
                    type="date"
                    id="lastSubmissionDate"
                    name="lastSubmissionDate"
                    value={updatedTender.lastSubmissionDate}
                    onChange={handleInputChange}
                    className="w-full p-2 text-sm border border-gray-300 rounded-md"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="openingDate" className="block text-sm font-medium text-gray-700">Opening Date</label>
                <input
                  type="date"
                  id="openingDate"
                  name="openingDate"
                  value={updatedTender.openingDate}
                  onChange={handleInputChange}
                  className="w-full p-2 text-sm border border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label htmlFor="pdfUrl" className="block text-sm font-medium text-gray-700">PDF URL</label>
                <input
                  type="text"
                  id="pdfUrl"
                  name="pdfUrl"
                  value={updatedTender.pdfUrl}
                  onChange={handleInputChange}
                  className="w-full p-2 text-sm border border-gray-300 rounded-md"
                />
              </div>
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  onClick={() => setShowUpdateForm(false)}
                  className="bg-gray-500 text-white px-4 py-2 rounded-md text-sm"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleUpdate}
                  className="bg-teal-500 text-white px-4 py-2 rounded-md text-sm"
                >
                  Update Tender
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Tenders Table */}
        <div className="overflow-x-auto rounded-lg shadow-md">
          <table className="min-w-full bg-white">
            <thead className="bg-teal-100">
              <tr>
                <th className="text-left py-3 px-2 sm:px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide">S No.</th>
                <th className="text-left py-3 px-2 sm:px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide">Description</th>
                <th className="text-left py-3 px-2 sm:px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide hidden sm:table-cell">Publication Date</th>
                <th className="text-left py-3 px-2 sm:px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide hidden md:table-cell">Last Submission Date</th>
                <th className="text-left py-3 px-2 sm:px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide hidden lg:table-cell">Opening Date</th>
                <th className="text-center py-3 px-2 sm:px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide">Actions</th>
              </tr>
            </thead>
            <tbody>
              {tenders.map((tender, index) => (
                <tr key={tender._id} className="border-b">
                  <td className="py-3 px-2 sm:px-4 text-gray-700 text-xs sm:text-sm">{index + 1}</td>
                  <td className="py-3 px-2 sm:px-4 text-gray-700 text-xs sm:text-sm">{tender.description}</td>
                  <td className="py-3 px-2 sm:px-4 text-gray-700 text-xs sm:text-sm hidden sm:table-cell">{tender.publicationDate}</td>
                  <td className="py-3 px-2 sm:px-4 text-gray-700 text-xs sm:text-sm hidden md:table-cell">{tender.lastSubmissionDate}</td>
                  <td className="py-3 px-2 sm:px-4 text-gray-700 text-xs sm:text-sm hidden lg:table-cell">{tender.openingDate}</td>
                  <td className="py-3 px-2 sm:px-4 text-center">
                    <button
                      onClick={() => {
                        setShowUpdateForm(true);
                        setUpdatedTender({
                          description: tender.description,
                          publicationDate: tender.publicationDate,
                          lastSubmissionDate: tender.lastSubmissionDate,
                          openingDate: tender.openingDate,
                          pdfUrl: tender.pdfUrl,
                        });
                        setCurrentTenderId(tender._id);
                      }}
                      className="text-teal-500 hover:text-teal-600 mr-2 sm:mr-4"
                    >
                      <Edit size={16} />
                    </button>
                    <button
                      onClick={() => handleDelete(tender._id)}
                      className="text-red-500 hover:text-red-600"
                    >
                      <Trash size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      <ToastContainer />
    </div>
  );
}